import React from 'react'
import cl from 'classnames'

import { Icon } from 'Shared/atoms'
import { IconType } from 'Shared/atoms/Icon'

import styles from './styles.module.scss'

const typeMap = {
	warning: styles.warning,
	default: styles.default,
	info: styles.info,
	error: styles.error,
	success: styles.success
}

interface AlertButton {
	text?: string
	onClick: () => void
	btnClassName?: string
}

export interface AlertProps {
	type?: 'warning' | 'default' | 'info' | 'error' | 'success'
	message: string | React.ReactNode
	className?: string
	iconClassName?: string
	icon?: IconType
	isHidden?: boolean
	button?: AlertButton
	contentClassName?: string
}

const Alert: React.FC<AlertProps> = (props) => {
	const {
		type,
		message,
		className,
		icon,
		iconClassName,
		isHidden = false,
		button,
		contentClassName
	} = props
	const typeClassName = typeMap[type || 'default']

	if (isHidden) {
		return null
	}
	return (
		<div className={cl(styles.basic, className, typeClassName)}>
			<div className={cl(styles.content, contentClassName)}>
				{icon && <Icon className={cl(styles.icon, iconClassName)} type={icon} />}
				<span>{message}</span>
			</div>
			{button && (
				<button onClick={button.onClick} className={cl(styles.btn, button.btnClassName)}>
					{button.text || 'Dismiss'}
				</button>
			)}
		</div>
	)
}

export default Alert
